// import { useNavigate } from 'react-router-dom';
import * as constants from './constants';
import controller from './controller';

import { clearCredentials, saveCredentials } from '../../../lib/api';
import {
  getUserPermissions,
  getUserRoles,
  resetUserPermissions,
  resetUserRoles,
} from '../../permissions/store/actions';
import { PROJECT_AVTOAPP } from '../../core/constants/projects.ts';

function generateDeviceId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const dispatchFail = (dispatch, failType, error, payload) => {
  return dispatch({ type: failType, payload: { loading: false, error, ...payload } });
};

export function resetError() {
  return dispatch => dispatch({ type: constants.RESET_ERROR, payload: { error: null } });
}

export function login(data) {
  return async dispatch => {
    dispatch({ type: constants.LOGIN, payload: { loading: true, error: null } });

    try {
      const loginResponse = await controller.login(data);
      const deviceId = generateDeviceId();

      if (loginResponse.errorData) {
        return dispatchFail(dispatch, constants.LOGIN_FAIL, loginResponse.errorData);
      }

      const token = loginResponse.headers && loginResponse.headers['x-authorization'];

      if (!token) {
        return dispatchFail(dispatch, constants.LOGIN_FAIL, {
          message: 'Введен неправильно логин или пароль, попробуйте еще раз.',
        });
      }      

      saveCredentials({ ...loginResponse.data, email: data.email, token });

      const profileResponse = await controller.getProfile({ token });

      //TODO -  очередная - ХЗ, сделаем или нет. Надо подумать над кейсами, когда не получили wsntToken и как сообщить об этом
      // маркеры на экране сделать "Хьюстон, мы Вас не видим"
      const wsntResponse = await controller.getNotificationsWsnt(deviceId);    
      const wsntToken = wsntResponse?.data?.wsnt ?? null;
      saveCredentials({
        ...loginResponse.data, email: data.email, token, deviceId, wsntToken, 
      });

      if (profileResponse.errorData) {
        return dispatchFail(dispatch, constants.LOGIN_FAIL, profileResponse.errorData);
      }

      return dispatch({
        type: constants.LOGIN_SUCCESS,
        payload: {
          profile: { ...profileResponse.data, token },
          loading: false,
          error: undefined,
        },
      });
    } catch (error) {
      return dispatchFail(dispatch, constants.LOGIN_FAIL, error);
    }
  };
}

export function logout() {
  // const navigate = useNavigate();

  return (dispatch) => {
    dispatch(resetUserPermissions());
    dispatch(resetUserRoles());

    clearCredentials();

    // navigate('/');
    window.location.href = '/';

    return dispatch({ type: constants.LOGOUT_SUCCESS, payload: { profile: {} } });
  };
}

export function getProfile({ token }) {
  return (dispatch) => {
    dispatch({ type: constants.FETCH_PROFILE, payload: { loading: true, error: null } });

    return controller.getProfile({ token }).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.FETCH_PROFILE_FAIL, response.errorData);
      }

      dispatch(getUserPermissions({ customerId: response.data.customerId, projectId: PROJECT_AVTOAPP }));
      dispatch(getUserRoles({ customerId: response.data.customerId }));

      return dispatch({
        type: constants.FETCH_PROFILE_SUCCESS,
        payload: { profile: { ...response.data, token }, loading: false, error: null },
      });
    });
  };
}

export function startRegistration() {
  return {
    type: constants.START_REGISTRATION,
    payload: { registrationCompleted: false, error: undefined },
  };
}

export function completeRegistration(data) {
  return dispatch => controller.completeRegistration(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.COMPLETE_REGISTRATION_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.COMPLETE_REGISTRATION_SUCCESS,
      payload: { registrationCompleted: true, error: undefined },
    });
  });
}

export function getRegistrationInfo(data) {
  return dispatch => controller.getRegistrationInfo(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_REGISTRATION_INFO_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_REGISTRATION_INFO_SUCCESS,
      payload: { registrationInfo: response.data, error: undefined },
    });
  });
}

export function restorePasswordStart(data) {
  return dispatch => controller.restorePasswordStart(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.RESTORE_PASSWORD_START_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.RESTORE_PASSWORD_START_SUCCESS,
      payload: { error: undefined },
    });
  });
}

export function restorePasswordEnd(data) {
  return dispatch => controller.restorePasswordEnd(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.RESTORE_PASSWORD_END_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.RESTORE_PASSWORD_END_SUCCESS,
      payload: { error: undefined },
    });
  });
}
